var $c94ab22311ee00dd$exports = {};
$c94ab22311ee00dd$exports = {
  "collapse": "\uC811\uAE30",
  "expand": "\uD3BC\uCE58\uAE30"
};
export { $c94ab22311ee00dd$exports as default };